import { render } from "./zhuguanjishi-news.vue?vue&type=template&id=f5ac81d6&scoped=true"
import script from "./zhuguanjishi-news.vue?vue&type=script&lang=js"
export * from "./zhuguanjishi-news.vue?vue&type=script&lang=js"

import "./zhuguanjishi-news.vue?vue&type=style&index=0&id=f5ac81d6&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ac81d6"]])

export default __exports__